"use strict";
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _AngularRestrictionApi_angularRestriction;
Object.defineProperty(exports, "__esModule", { value: true });
exports.AngularRestrictionApi = void 0;
const AbstractSnapRestrictionApi_1 = require("../../AbstractSnapRestrictionApi");
class AngularRestrictionApi extends AbstractSnapRestrictionApi_1.AbstractSnapRestrictionApi {
    // #endregion Properties (1)
    // #region Constructors (1)
    constructor(restriction) {
        super(restriction);
        // #region Properties (1)
        _AngularRestrictionApi_angularRestriction.set(this, void 0);
        __classPrivateFieldSet(this, _AngularRestrictionApi_angularRestriction, restriction, "f");
    }
    // #endregion Constructors (1)
    // #region Public Getters And Setters (2)
    get angleStep() {
        return __classPrivateFieldGet(this, _AngularRestrictionApi_angularRestriction, "f").angleStep;
    }
    set angleStep(value) {
        __classPrivateFieldGet(this, _AngularRestrictionApi_angularRestriction, "f").angleStep = value;
    }
    get angleStepEditable() {
        return __classPrivateFieldGet(this, _AngularRestrictionApi_angularRestriction, "f").angleStepEditable;
    }
}
exports.AngularRestrictionApi = AngularRestrictionApi;
_AngularRestrictionApi_angularRestriction = new WeakMap();
//# sourceMappingURL=AngularRestrictionApi.js.map